import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import { useParams } from 'react-router'

import { delugeIdAtom } from '@root/entities/auth'
import { profileAtom } from '@root/entities/profile'
import { DelugeId } from '@root/entities/user-short/model'
import { StatisticsTables } from '@root/features/profile/board-statistics/ui/profile-board-statistics-tables'
import { DistributeDrawerDt } from '@root/features/profile/distribute-drawer'
import { profileBoardAtom } from '@root/features/user/profile/atoms/reatom-profile-boards'
import { ProfileTabs } from '@root/features/user/profile/model/profile-tabs'
import { UserProfileTabs } from '@root/features/user/profile/model/user-profile-tab'
import { userTradingAnalyticsPeriodAtom } from '@root/features/user/user-trading-analytics/atoms'

import { Board } from './common'
import { ProfileBoardContent } from './profile-board-content'
import { ProfilePageTabs } from './profile-page-tabs'

export const ProfileBoard = () => {
  const params = useParams<'delugeId'>()

  const [profileBoard, setProfileBoard] = useAtom(profileBoardAtom)
  const [profile] = useAtom(profileAtom)
  const [currentDelugeId] = useAtom(delugeIdAtom)
  const [period] = useAtom(userTradingAnalyticsPeriodAtom)

  const delugeId = useMemo(() => {
    const pathDelugeId = params.delugeId
    if (!pathDelugeId) {
      return currentDelugeId
    }
    if (pathDelugeId === currentDelugeId) {
      return currentDelugeId
    }
    return DelugeId(pathDelugeId)
  }, [currentDelugeId, params.delugeId])
  const isCurrentUser = delugeId === currentDelugeId

  const isStatistics = profileBoard === 'statistics'

  return (
    <>
      <Board isTransparent={isStatistics} fullHeight={!isStatistics}>
        <ProfilePageTabs
          tabs={isCurrentUser ? ProfileTabs : UserProfileTabs}
          tab={profileBoard}
          onTabChange={setProfileBoard}
        />

        {delugeId ? (
          <ProfileBoardContent
            tab={profileBoard}
            delugeId={delugeId}
            owner={isCurrentUser ? 'current-user' : 'other-user'}
          />
        ) : undefined}
      </Board>
      {isStatistics && delugeId ? (
        <>
          <StatisticsTables
            delugeId={delugeId}
            wallets={profile?.wallets ?? []}
          />
          <DistributeDrawerDt delugeId={delugeId} period={period} />
        </>
      ) : undefined}
    </>
  )
}
